export default __webpack_public_path__ + "static/media/athens.09df9513.png";